import { CaptionLineConfig } from '../types/asset-types';
import { SpeakerLabelTransitionEffect } from '../types/transitions';

export const SPEAKER_LABEL_DEFAULT_TRANSITIONS = {
  in: SpeakerLabelTransitionEffect.None,
  out: SpeakerLabelTransitionEffect.None,
  showAfter: 0,
  hideAfter: undefined,
  showAgainOnNewSpeaker: true,
  duration: 0.3
};
export const MAIN_TRACK_ID = 'main';
export const CAPTIONS_LINE_COUNT_MAP = {
  [CaptionLineConfig.OneLine]: 1,
  [CaptionLineConfig.TwoLines]: 2,
  [CaptionLineConfig.ThreeLines]: 3
} as const;
export const DEFAULT_FONT_SIZE = 48;
export const VIDEO_ASPECT_RATIO = 16 / 9;
